import { render } from "./CampaignLayout.vue?vue&type=template&id=25d27bb2&scoped=true"
import script from "./CampaignLayout.vue?vue&type=script&lang=js"
export * from "./CampaignLayout.vue?vue&type=script&lang=js"

import "./CampaignLayout.vue?vue&type=style&index=0&id=25d27bb2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d27bb2"]])

export default __exports__